var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-version-badge",attrs:{"title":_vm.statusTitle}},[_c('span',{staticClass:"avb-dot",class:_vm.statusClass}),_c('span',{staticClass:"avb-version"},[_vm._v("v"+_vm._s(_vm.localVersion || '?'))]),(_vm.statusLabel)?_c('span',{staticClass:"avb-status",class:_vm.statusClass},[_vm._v(_vm._s(_vm.statusLabel))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }